import { render, staticRenderFns } from "./Winlose.vue?vue&type=template&id=987a4766&scoped=true&"
import script from "./Winlose.vue?vue&type=script&lang=js&"
export * from "./Winlose.vue?vue&type=script&lang=js&"
import style0 from "./Winlose.vue?vue&type=style&index=0&id=987a4766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a4766",
  null
  
)

export default component.exports